import React from 'react';
import { useTranslation } from 'react-i18next';
import { WESPLink, SocialIntranetSUMS } from '@/helpers/constants';
import ConfirmDialog from '../UI/Dialog/ConfirmDialog';
import styles from './SumsCriteriaPopup.module.scss';

interface SumsCriteriaPopupProps {
  open: boolean;
  close: () => void;
}

// POPUP for ticket CART-10455 and CART-10456
const SumsCriteriaPopup: React.FC<SumsCriteriaPopupProps> = (props) => {
  const { open, close } = props;
  const { t } = useTranslation();

  return open ? (
    <ConfirmDialog close={close} title={t('dialog.sumsCriteria.title')} closeBtnText={t('dialog.close')}>
      <div className={styles.SumsCriteriaPopupContent}>
        <p data-testid="sums-criteria-popup-dialog-paragraph-1">{t('dialog.sumsCriteria.line1')}</p>
        <p data-testid="sums-criteria-popup-dialog-paragraph-2">{t('dialog.sumsCriteria.line2')}{' '}
          <a target="_blank" href={WESPLink} rel="noreferrer">WESP</a>{' '}
          (Link:{' '}
          <a target="_blank" href={WESPLink} rel="noreferrer">{WESPLink}</a>)
          {t('dialog.sumsCriteria.line3')}
        </p>
        <p data-testid="sums-criteria-popup-dialog-paragraph-3">{t('dialog.sumsCriteria.line4')}
          {' '}<a target="_blank" href={SocialIntranetSUMS} rel="noreferrer">Social Intranet</a>{' '}
          (Link: <a target="_blank" href={SocialIntranetSUMS} rel="noreferrer">{SocialIntranetSUMS}</a>)
        </p>
      </div>
    </ConfirmDialog>
  ) : null;
};

export default SumsCriteriaPopup;
